import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function Banners() {
  const [banners, setBanners] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [bannerType, setBannerType] = useState("All");

  const location = useLocation();
  const bannersPerPage = 12;

  // ✅ Toast on banner added (from navigation state)
  useEffect(() => {
    if (location.state?.bannerAdded) {
      toast.success("Banner added successfully");
      window.history.replaceState({}, document.title); // Prevents re-toast on refresh
    }
  }, [location.state]);

  // 🔄 Fetch all banners from backend
  useEffect(() => {
    fetch("https://backend-zkgn.onrender.com/api/banners")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setBanners(data);
        } else {
          console.error("Expected array but got:", data);
          toast.error("Invalid banner data received from server");
        }
      })
      .catch(() => toast.error("Failed to load banners"));
  }, []);

  const filteredBanners =
    bannerType === "All"
      ? banners
      : banners.filter((b) => b.banner_type === bannerType);

  const indexOfLast = currentPage * bannersPerPage;
  const indexOfFirst = indexOfLast - bannersPerPage;
  const currentBanners = filteredBanners.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredBanners.length / bannersPerPage);

  const handleBannerTypeChange = (e) => {
    setBannerType(e.target.value);
    setCurrentPage(1);
  };

  // 🧹 Delete Banner
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;

    try {
      const res = await fetch(`https://backend-zkgn.onrender.com/:3002/api/banners/${id}`, {
        method: "DELETE",
      });

      if (res.ok) {
        setBanners((prev) => prev.filter((b) => b.banner_id !== id));
        toast.success("Banner deleted successfully");
      } else {
        toast.error("Failed to delete banner");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error deleting banner");
    }
  };

  // ✅ Toggle Active Status
  const toggleActive = async (id, currentStatus) => {
    try {
      const res = await fetch(`https://backend-zkgn.onrender.com/api/banners/${id}/status`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ isActive: !currentStatus }),
      });

      if (res.ok) {
        setBanners((prev) =>
          prev.map((b) =>
            b.banner_id === id ? { ...b, isActive: !currentStatus } : b
          )
        );
        toast.success("Banner status updated");
      } else {
        toast.error("Failed to update status");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating status");
    }
  };

  return (
    <div className="container-fluid my-4">
      <ToastContainer position="top-right" autoClose={2000} />

      {/* Filter + Add Banner */}
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <label className="form-label mb-0 me-2">Select Banner Type:</label>
          <select
            className="form-select w-auto"
            value={bannerType}
            onChange={handleBannerTypeChange}
          >
            <option value="All">All</option>
            <option value="Home Page Banner">Home Page Banner</option>
            <option value="Supplier Banner">Supplier Page Banner</option>
            <option value="Side Banner">Side Banner</option>
            <option value="InSide Banner">InSide Banner</option>
          </select>
        </div>

        <Link to="/addbanner" className="btn btn-primary">
          Add New Banner
        </Link>
      </div>

      {/* Banner Grid */}
      <div className="row">
        {currentBanners.map((banner) => (
          <div className="col-lg-4 col-md-6 mb-4" key={banner.banner_id}>
            <div className="card banner-card shadow-sm h-100">
              <div className="banner-image-wrapper">
                <img
                  src={`https://backend-zkgn.onrender.com/uploads/${banner.banner_image_link}`}
                  alt="Banner"
                  className="banner-img"
                />

              </div>

              <div className="banner-actions d-flex justify-content-between align-items-center px-3 py-2">
                <Link
                  to={`/banners/${banner.banner_id}`}
                  className="text-primary d-flex align-items-center"
                >
                  <i className="fa fa-eye me-1"></i> View
                </Link>

                <button
                  className="btn btn-link text-danger p-0 d-flex align-items-center"
                  onClick={() => handleDelete(banner.banner_id)}
                >
                  <i className="fa fa-trash me-1"></i> Delete
                </button>

                <div className="form-check mb-0 d-flex align-items-center">
                  <input
                    type="checkbox"
                    className="form-check-input me-1"
                    id={`active-${banner.banner_id}`}
                    checked={banner.isActive}
                    onChange={() =>
                      toggleActive(banner.banner_id, banner.isActive)
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`active-${banner.banner_id}`}
                  >
                    Is Active
                  </label>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="pagination-container mt-4 text-center">
        <button
          className="pagination-btn"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => prev - 1)}
        >
          Previous
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index + 1}
            className={`pagination-btn ${currentPage === index + 1 ? "active" : ""}`}
            onClick={() => setCurrentPage(index + 1)}
          >
            {index + 1}
          </button>
        ))}
        <button
          className="pagination-btn"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((prev) => prev + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Banners;
